import axios, { AxiosRequestHeaders, AxiosResponseHeaders } from "axios";
import { useAuthStore, useCompanyStore } from "../store";
import { attachAuthRefresh } from "./authRefresh";
import { optionsAdminAuth } from "./adminAuthMode";

const optionsApi = axios.create({
  baseURL:
    (optionsAdminAuth
      ? process.env.REACT_APP_OPTIONS_API
      : sessionStorage.getItem("esopNodeApi")) ||
    process.env.REACT_APP_OPTIONS_API ||
    "http://localhost:4000",
});
optionsApi.defaults.headers.post["Content-Type"] = "application/json";
optionsApi.defaults.headers.common["Access-Control-Expose-Headers"] =
  "companyId";
if (optionsAdminAuth) {
  optionsApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";
}
optionsApi.interceptors.request.use((config) => {
  const accesstoken = useAuthStore.getState().accessToken;
  if (accesstoken && !config.url?.endsWith("/login")) {
    const companyId =
      sessionStorage.getItem("companyId") ||
      useCompanyStore.getState().companyData?.id ||
      "";
    if (!(config.headers as AxiosRequestHeaders).Authorization) {
      (config.headers as AxiosRequestHeaders).Authorization = accesstoken;
    }
    const explicitImportCompany = /^\/?v1\/mcp\/uploads\//.test(
      config.url || ""
    )
      ? (config.headers as AxiosRequestHeaders).companyId
      : undefined;
    (config.headers as AxiosRequestHeaders).companyId =
      explicitImportCompany || companyId;
  }
  return config;
});
optionsApi.interceptors.response.use((res) => {
  if (
    !sessionStorage.getItem("companyId") &&
    (res.headers as AxiosResponseHeaders)?.companyId
  ) {
    sessionStorage.setItem(
      "companyId",
      (res.headers as AxiosResponseHeaders).companyId
    );
  }
  return res;
});

attachAuthRefresh(optionsApi, "Authorization");

export default optionsApi;
